export function FromSoftware(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      {}
      <g
        fill="none"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path
          strokeLinecap="round"
          d="M17.67 16c.843-1.18 1.33-2.59 1.33-4c0-4-1.5-5-1.5-5c-.538 1.5-2 2-2 2c0-5.5-3.5-7-3.5-7S8.5 3.5 8.5 9c0 0-1.462-.5-2-2C6.5 7 5 8 5 12c0 1.41.487 2.82 1.329 4"
        />
        <path d="M19 19H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z" />
        <path
          strokeLinecap="round"
          d="M14.5 16c0-2.5-2.5-5-2.5-5s-2.5 2.5-2.5 5"
        />
      </g>
    </svg>
  );
}
